import type { LinksFunction } from '@remix-run/node';

/** The landing's type for pages outside it, like sign-in: Libre Baskerville from Google Fonts, ABC Areal from the site. */
export const brandFontLinks: LinksFunction = () => [
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville&display=swap' },
  { rel: 'preload', href: '/landing/fonts/ABCArealSuperfamilyVariable.ttf', as: 'font', type: 'font/ttf', crossOrigin: 'anonymous' },
];
